import { render, staticRenderFns } from "./ManageChildren.vue?vue&type=template&id=853c96fe&scoped=true&"
import script from "./ManageChildren.vue?vue&type=script&lang=js&"
export * from "./ManageChildren.vue?vue&type=script&lang=js&"
import style0 from "./ManageChildren.vue?vue&type=style&index=0&id=853c96fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853c96fe",
  null
  
)

export default component.exports